import { c as _c } from "react/compiler-runtime";
import { HStack, Heading, Text, VStack, Separator } from '@chakra-ui/react';
interface ConsultingCardProps {
  companyName?: string;
  companyElevatorPitch?: string;
  totalFundingAmount?: string;
  bgColor?: string;
  bgImage?: string;
}
const ConsultingCard: React.FC<ConsultingCardProps> = t0 => {
  const $ = _c(18);
  const {
    companyName,
    companyElevatorPitch,
    totalFundingAmount,
    bgColor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text opacity={0.5} textStyle="badgeSm">Consulting Logo</Text>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== companyName) {
    t2 = <Heading lineHeight="shorter" size="3xl">{companyName}</Heading>;
    $[1] = companyName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== companyElevatorPitch) {
    t3 = <Text fontSize="lg" opacity={0.7}>{companyElevatorPitch}</Text>;
    $[3] = companyElevatorPitch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <VStack align="flex-start">{t2}{t3}</VStack>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator border="2px solid" borderColor="whiteAlpha.300" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text textStyle="badgeXs">Total Commitments</Text>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== totalFundingAmount) {
    t7 = <VStack align="flex-start" gap={0}>{t6}<HStack gap={3}><Text fontSize="3xl" fontWeight={700} textStyle="labelLg">{totalFundingAmount}</Text></HStack></VStack>;
    $[10] = totalFundingAmount;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <VStack align="flex-start" gap={4}>{t4}{t5}{t7}</VStack>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== bgColor || $[16] !== t8) {
    t9 = <><VStack align="flex-start" bgColor={bgColor} borderRadius="2xl" boxShadow="sm" gap={12} justify="space-between" padding={6}>{t1}{t8}</VStack></>;
    $[15] = bgColor;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default ConsultingCard;